import React from 'react';
import { CheckCircle2, Clock, Users, Award } from 'lucide-react';

export const WhyChooseUs = () => {
  const reasons = [
    {
      icon: CheckCircle2,
      title: 'Expert Technicians',
      description: 'Our team is fully certified and trained in the latest water treatment technologies and best practices.'
    },
    {
      icon: Clock,
      title: 'Fast Response Time',
      description: 'Same-day service available for emergencies. We understand water issues can\'t wait.'
    },
    {
      icon: Users,
      title: 'Customer-First Approach',
      description: 'Transparent pricing, no hidden fees, and honest recommendations for your specific situation.'
    },
    {
      icon: Award,
      title: 'Quality Guarantee',
      description: 'All installations backed by comprehensive warranties and ongoing support.'
    }
  ];

  return (
    <section id="about" className="py-20 text-white" style={{ backgroundColor: '#0C4288' }}>
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          {/* ── CONVERSION IQ COPY: "Why Choose Aquify" Section Header ────────────
               This section headline and sub-copy are prime targets for Conversion IQ.
               Replace the <h2> text and the <p> below with Conversion IQ copy.
          ─────────────────────────────────────────────────────────────────────── */}
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Why Choose <span style={{ color: '#50BAED' }}>Aquify</span>?
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            We're Long Island's trusted water treatment experts, committed to delivering 
            exceptional service and treated water solutions.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-10">
          {reasons.map((reason, index) => {
            const Icon = reason.icon;
            return (
              <div 
                key={index} 
                className="flex gap-6 p-8 rounded-lg border transition-all duration-300 hover:shadow-xl"
                style={{ backgroundColor: '#1571BA', borderColor: '#1571BA' }}
                onMouseEnter={(e) => e.currentTarget.style.borderColor = '#50BAED'}
                onMouseLeave={(e) => e.currentTarget.style.borderColor = '#1571BA'}
              >
                <div className="flex-shrink-0">
                  <div className="p-4 rounded-lg" style={{ backgroundColor: 'rgba(80, 186, 237, 0.2)' }}>
                    <Icon className="h-8 w-8" style={{ color: '#FFFFFF' }} />
                  </div>
                </div>
                {/* ── CONVERSION IQ COPY: Benefit Card #{index+1} ───────────────────────
                   Each card title + description below can be replaced with
                   Conversion IQ benefit statements. Keep 4 cards, or adjust
                   the reasons array above to match the CIQ benefit count.
              ─────────────────────────────────────────────────────────────────────── */}
              <div>
                <h3 className="text-2xl font-bold mb-3">{reason.title}</h3>
                <p className="text-gray-300 text-lg leading-relaxed">{reason.description}</p>
              </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
